export const useDocumentActiveTypeStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentActiveTypes(documentId, revision.id)();
};
